// src/components/SeasonSelector.js

import React from 'react';
import { useSeason } from '../contexts/SeasonContext';
import { getRecentSeasons } from '../utils/seasonUtils';
import '../styles/SeasonSelector.css';

function SeasonSelector() {
    const { selectedSeason, setSelectedSeason } = useSeason();
    const seasons = getRecentSeasons(); // Get all available seasons back to 2009-2010

    const handleSeasonChange = (e) => {
        setSelectedSeason(e.target.value);
    };

    return (
        <div className="season-selector">
            <label htmlFor="season-select" className="season-label">
                Season:
            </label>
            <select
                id="season-select"
                value={selectedSeason}
                onChange={handleSeasonChange}
                className="season-dropdown"
            >
                {seasons.map(season => (
                    <option key={season} value={season}>
                        {season}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default SeasonSelector;
